import { useMemo } from 'react';

import { useGetUserServicesProviders } from '@common/hooks/useGetUserServicesProviders';

/**
 * Maps svpId values to human-readable account names.
 * Falls back to the raw svpId when no matching services provider is found.
 */
export function useAccountNameMap(): Map<string, string> {
	const { servicesProviders } = useGetUserServicesProviders();

	return useMemo(() => {
		const map = new Map<string, string>();
		servicesProviders.forEach((sp) => {
			map.set(sp.id, sp.name || sp.id);
		});
		return map;
	}, [servicesProviders]);
}
